import regeneratorRuntime from "regenerator-runtime";

export default class Utilitiesjs {
    constructor() {

    }

    isEmail(email) {
        const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return expression.test(String(email).toLowerCase());
    }

    showInlineById(elementId) {
        document.getElementById(elementId).style.display = 'inline';
    }

    showById(elementId) {
        document.getElementById(elementId).style.display = 'block';
    }

    hideById(elementId) {
        document.getElementById(elementId).style.display = 'none';
    }

    changeInnerHtmlById(elementId, text) {
        document.getElementById(elementId).innerHTML = text;
    }

    clearById(sectionId) {
        document.getElementById(sectionId).innerHTML = "";
    }

    getSelectedValue(selectListId) {
        var ddl = document.getElementById(selectListId);
        return ddl.options[ddl.selectedIndex].value;
    }

    getSelectedText(selectListId) {
        var ddl = document.getElementById(selectListId);
        return ddl.options[ddl.selectedIndex].text;
    }


    disableButton(e) {
        var button = e.target.getElementsByTagName("button")[0];
        button.disabled = true;
        return button;
    }



    formatDate(dateInput) {
        return `${dateInput.getFullYear()}-${dateInput.getMonth() + 1}-${dateInput.getDate()}`;
    }

    setInputDateMax(selectDateId) {
        document.getElementById(selectDateId).setAttribute("max", this.formatDate(new Date()));
    }

    maskPhone(element, name) {
        return $(`${element}[name=${name}]`).mask('000 000 0000');
    }

    validateInput(data) {
        let validated = true;
        for (var key in data) {
            if (!data[key]) {
                validated = false;
            }
        }
        return validated;
    }

    validateInputWithLabels(data) {
        let validated = true;
        for (var key in data) {
            if (!data[key]) {
                validated = false;
                this.showById(`${key}Validate`);
            } else {
                this.hideById(`${key}Validate`);
            }
        }
        return validated;
    }

    trim(str) {
        return str.replace(/(^\s*)|(\s*$)/g, "");
    }

    changeImgSrc(imgId, src) {
        document.getElementById(imgId).src = src;
    }

    changeOnclick(id, call) {
        document.getElementById(id).setAttribute('onclick', call);
    }

    addClass(id, className) {
        document.getElementById(id).classList.add(className);
    }
    removeClass(id, className) {
        document.getElementById(id).classList.remove(className);
    }

    async sleep(milliseconds) {
        return new Promise((res, rej) => {
            window.setTimeout(res, milliseconds);
        });
    }

    enforceCamelCase(obj) {
        let formattedObj = {};
        for (var key of Object.keys(obj)) {
            if (typeof obj[key] == "object") obj[key] = this.enforceCamelCase(obj[key]);
            formattedObj[key[0].toUpperCase() + key.slice(1)] = obj[key];
        }
        return formattedObj;
    }

    enforceUpperCase(obj) {
        let formattedObj = {};
        for (var key of Object.keys(obj)) {
            if (typeof obj[key] == "object") obj[key] = this.enforceUpperCase(obj[key]);
            formattedObj[key.toUpperCase()] = obj[key];
        }
        return formattedObj;
    }

    prettyPrintJSON(obj) {
        let objToString = null;
        objToString = function (current) {
            let str = "";
            if (Array.isArray(current)) {
                for (let i = 0; i < current.length; i++) {
                    str += objToString(current[i]);
                    str += "\r\n\r\n";
                }
            }
            else {
                const keys = Object.keys(current);
                for (let i = 0; i < keys.length; i++) {
                    const value = current[keys[i]];
                    if (typeof value == "object")
                        str += keys[i] + ":" + objToString(value);
                    else
                        str += keys[i] + ":" + value.toString();
                    str += "\r\n";
                }
            }

            return str;
        }
        return objToString(obj)
    }

    urlEncodedToJson(str) {
        return decodeURIComponent(str)
            .split("&").reduce((obj, curr) => {
                const parts = curr.split("=");
                obj[parts[0]] = parts[1];
                return obj;
            }, {});
    }

    //datepicker for Safari only
    isSafari() {
        return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
            navigator.userAgent &&
            navigator.userAgent.indexOf('CriOS') == -1 &&
            navigator.userAgent.indexOf('FxiOS') == -1 &&
            !navigator.userAgent.match('FxiOS');
    }

    loadSafariDatePicker() {
        if (this.isSafari()) {
            //get initial values
            var values = $(".datepicker").map(function () { return this.value; });

            $(".datepicker").datepicker({
                changeMonth: true,
                changeYear: true
            });
            $(".datepicker").datepicker("option", "dateFormat", "yy-mm-dd");

            $(".datepicker[max]").each((index, ele) => {
                let thisDatepicker = $(ele);
                thisDatepicker.datepicker('option', 'minDate', new Date(thisDatepicker.attr('min')));
                thisDatepicker.datepicker('option', 'maxDate', new Date(thisDatepicker.attr('max')));
            });
            //reassign initial values
            $(".datepicker").map(function (i) { this.value = values.get(i); });
        }
    }

    disableAutoFill() {
        if (typeof $ != 'undefined') {
            $('input[autocomplete="off"]').focus(function () {
                $(this).attr('autocomplete', 'new-password');
            });
            $('input[autocomplete="off"]').blur(function () {
                $(this).attr('autocomplete', 'off');
            });
        }
    }

}


// WEBPACK FOOTER //
// ./Scripts/es6/utilites.js